<script>
/* eslint-disable global-require */
const seLight = {
  appLogo: '',
  companyLogo1: require('@/assets/images/logo/SE powered by FVC narrow.png'),
  companyLogo2: '',
}

const seDark = {
  appLogo: '',
  companyLogo1: require('@/assets/images/logo/SE powered by FVC narrow - dark.png'),
  companyLogo2: '',
}

export default {
  computed: {
    skin() {
      return this.$store.state.appConfig.layout.skin
    },
    seBrand() {
      if (this.skin === 'light') {
        return seLight
      }
      return seDark
    },
  },
}
</script>
